<template>
  <div>

    <div class="gameplay_title_container">
      <div class="gameplay_title">
        {{ gameInfo.question }}
      </div>
    </div>
    <div class="gameplay_game_box_list gameplay_tap_box">
      <div class="input_area_boxes">
        <div class="row">
          <div :class="cssResult">
            {{value1}}
          </div>
          <p>{{operator}}</p>
          <div :class="cssResult">
            {{value2}}
          </div>
        </div>
        <div class="row answer">
          <p>=</p>
          <div class="numb_obj">
            {{result}}
          </div>
        </div>
      </div>
      <div class="gameplay_divider"></div>

      <div class="input_area_ans">


      <div v-for="(row, rowIndex) in numOfRow" :key="row" class="row">
        <div  v-for="(answer, index) in numOfCols" :key="index"
             @click="loading(rowIndex, (index))"
             :class="selectedButtonCss(twoDimensionalTable[rowIndex][index]) ? 'numb_obj_ans selected' : 'numb_obj_ans'"
             :style="!selectedButtonCss(twoDimensionalTable[rowIndex][index]) ? 'cursor:pointer' : 'pointer-events:none'"
        >
          {{ twoDimensionalTable[rowIndex][index] }}
        </div>
      </div>
      </div>
    </div>

  </div>
</template>

<script>
  /* eslint no-console: "off" */

import { mapGetters, mapState } from 'vuex';
import NewGameMixin from '@/common/mixins/home';
import { GameMixin2, ParseResponseMixin } from '@/common/mixins/game';
import { equalHeightAndWidth } from '@/common/jQuery';

export default {
  name: 'LogicPairs',
  mixins: [ParseResponseMixin, NewGameMixin, GameMixin2],
  data() {
    return {
      correctResult: false,
      userHasAnswered: false,
      numOfRow: 0,
      numOfCols: 4,
      matrixOperator: {
        ADDITION: {
          operator: '+',
        },
        SUBTRACTION: {
          operator: '-',
        },
        MULTIPLICATION: {
          operator: '*',
        },
        DIVISION: {
          operator: '/',
        },
      },
      numbersRegistered: 0,
      operator: '',
      value1: '?',
      value2: '?',
      result: '',
      cssResult: 'numb_obj one',
      gameInfo: null,
      buttonPushed: false,
      twoDimensionalTable: [],
    };
  },
  created() {
    this.initGameData();
  },
  mounted() {
    equalHeightAndWidth();
  },
  methods: {

    loadImage() {
    },
    initGameData() {
      this.gameInfo = this.miniGames[this.currentMiniGameRound];
      console.log(this.gameInfo);
      this.operator = this.matrixOperator[this.gameInfo.logicOperator].operator;
      this.result = this.gameInfo.result;
      this.createMatrix();
    },
    createMatrix() {
      let index = 0;
      this.numOfRow = this.gameInfo.numbers.length === 12 ? 3 : 2;
      this.twoDimensionalTable = Array(this.numOfRow).fill().map(() => Array(this.numOfCols).fill());
      for (let i = 0; i < this.numOfRow; i += 1) {
        for (let j = 0; j < this.numOfCols; j += 1) {
          this.twoDimensionalTable[i][j] = this.gameInfo.numbers[index];
          index += 1;
        }
      }
    },
    sendAnswer() {
      // eslint-disable-next-line no-nested-ternary
      const indexToBack = this.correctResult ? 1 : 0;
      let isCorrectAnswer = false;
      if (this.buttonPushed) {
        console.log('--> User 2 times. Wait for Answer....');
      } else {
        this.buttonPushed = true;
        this.$axios({
          url: `api/sendAnswerBrainiac?gameId=${this.gameID}&miniGameId=${this.gameInfo.id}&answerIndex=${indexToBack}`,
          method: 'GET',
          headers: {
            Authorization: this.jwtInVuex,
          },
        }).then((response) => {
          const responseData = response.data.data;
          if (response.data.responseEnum === 'OPERATION_SUCCESS') {
            if (responseData.status === 'WRONG_ANSWER') {
              isCorrectAnswer = false;
            } else if (responseData.status === 'CORRECT_ANSWER') {
              isCorrectAnswer = true;
            }
          }
          console.log('wait 1,5 secs for response and go to next game');
          setTimeout(() => {
            console.log('Go to next game');
            this.normalTransition = true;
            this.storeBrainiacGameData(isCorrectAnswer);
          }, 1500);
        }).catch((error) => {
          console.log(`Invoking api/sendAnswer failed with the following error: ${error}`);
        });
      }
    },
    loading(row, index) {
      const value = this.twoDimensionalTable[row][index];
      if (this.numbersRegistered === 0) {
        this.value1 = value;
        this.numbersRegistered += 1;
      } else if (this.numbersRegistered === 1 && this.value1 !== value) {
        this.value2 = value;
        this.numbersRegistered += 1;
      }
      if (this.numbersRegistered >= 2 && !this.userHasAnswered) {
        let calculation;
        this.userHasAnswered = true;
        if (this.operator === '+') {
          calculation = parseInt(this.value1, 10) + parseInt(this.value2, 10);
        }
        if (this.operator === '-') {
          calculation = parseInt(this.value1, 10) - parseInt(this.value2, 10);
        }
        if (this.operator === '/') {
          if (parseInt(this.value1, 10) % parseInt(this.value2, 10) === 0) {
            calculation = parseInt(this.value1, 10) / parseInt(this.value2, 10);
          } else {
            calculation = -1;
          }
        }
        if (this.operator === '*') {
          calculation = parseInt(this.value1, 10) * parseInt(this.value2, 10);
        }
        if (calculation === parseInt(this.result, 10)) {
          this.correctResult = true;
          this.cssResult = 'numb_obj one correct';
        } else {
          this.cssResult = 'numb_obj one wrong';
        }
        this.sendAnswer();
      }
    },
    selectedButtonCss(value) {
      if (value === this.value1 || value === this.value2) {
        return true;
      }
      return false;
    },
  },
  computed: {
    ...mapState('profile', [
      'jwtInVuex',
    ]),
    ...mapState('game', [
      'gameID',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/logic/LogicPairs.vue